var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import t from '@jetshop/intl';
import { FlyoutTarget, FlyoutTrigger } from '@jetshop/ui/Modal/Flyout';
import SuggestedTerm from '@jetshop/ui/Search/SuggestedTerm';
import * as React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import SearchAutoCompleteContainer from './SearchAutoCompleteContainer';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wa26s9a"
});
const SearchFieldWrapper = /*#__PURE__*/styled('div')({
  name: "SearchFieldWrapper",
  class: "sln4fmk"
});
const Flyout = /*#__PURE__*/styled('div')({
  name: "Flyout",
  class: "fjr5jt6"
});
const CancelButton = /*#__PURE__*/styled('button')({
  name: "CancelButton",
  class: "ct14fqm"
});
const resultStyles = "rsa1ms";

const SearchResults = ({
  term,
  result,
  loading,
  onClick
}) => {
  const products = result === null || result === void 0 ? void 0 : result.products;
  const categories = result === null || result === void 0 ? void 0 : result.categories;

  if (!loading && (products === null || products === void 0 ? void 0 : products.result.length) === 0 && (categories === null || categories === void 0 ? void 0 : categories.result.length) === 0) {
    return null;
  }

  return React.createElement("div", {
    className: resultStyles
  }, (products === null || products === void 0 ? void 0 : products.result.length) > 0 && React.createElement(React.Fragment, null, React.createElement("h2", null, t('Products')), React.createElement("ul", {
    style: loading ? {
      opacity: 0.5
    } : null
  }, products.result.map(item => React.createElement(SuggestedTerm, {
    term: term,
    onClick: onClick,
    key: item.id,
    item: item
  })))), (categories === null || categories === void 0 ? void 0 : categories.result.length) > 0 && React.createElement(React.Fragment, null, React.createElement("h2", null, t('Categories')), React.createElement("ul", {
    style: loading ? {
      opacity: 0.5
    } : null
  }, categories.result.map(item => React.createElement(SuggestedTerm, {
    term: term,
    onClick: onClick,
    key: item.id,
    item: item
  })))));
};

const SearchField = _a => {
  var {
    initialValue,
    className,
    placeholder = '',
    autocompleteQuery
  } = _a,
      rest = __rest(_a, ["initialValue", "className", "placeholder", "autocompleteQuery"]);

  throwErrorInDev(!autocompleteQuery, `You forgot to pass 'autocompleteQuery' to SearchField`);
  return React.createElement(SearchAutoCompleteContainer, Object.assign({
    autocompleteQuery: autocompleteQuery,
    initialValue: initialValue,
    focusOnLoad: true
  }, rest), searchField => React.createElement(Wrapper, {
    className: className,
    "data-flight-searchfield": ""
  }, React.createElement(SearchFieldWrapper, null, React.createElement(FlyoutTrigger, {
    showCover: false,
    id: "searchFlyout"
  }, ({
    showTarget,
    hideTarget
  }) => React.createElement(React.Fragment, null, React.createElement("input", Object.assign({
    placeholder: placeholder
  }, searchField.getInputProps({
    onFocus: showTarget
  }), {
    "data-flight-search-autocomplete-field": ""
  })), React.createElement(CancelButton, Object.assign({}, searchField.getCancelProps({
    onClick: hideTarget
  }), {
    "data-flight-searchfield-cancel": true
  }), t('Cancel')))), React.createElement(FlyoutTarget, {
    id: "searchFlyout"
  }, flyout => {
    var _a, _b, _c, _d;

    const hasResults = ((_b = (_a = searchField.result) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.result.length) > 0 || ((_d = (_c = searchField.result) === null || _c === void 0 ? void 0 : _c.categories) === null || _d === void 0 ? void 0 : _d.result.length) > 0;
    const {
      loading,
      isDirty,
      isOpen
    } = searchField;
    const showFlyout = isDirty && !loading && hasResults && isOpen && flyout.isOpen;

    if (showFlyout) {
      return React.createElement(Flyout, {
        "data-flight-searchfield-flyout": true
      }, React.createElement("div", Object.assign({}, searchField.getFlyoutProps()), searchField.isDirty && React.createElement(React.Fragment, null, React.createElement(SearchResults, {
        term: searchField.term,
        result: searchField.result,
        onClick: flyout.hideTarget,
        loading: searchField.loading
      }))));
    }

    return null;
  }))));
};

SearchField.Flyout = Flyout;
SearchField.Wrapper = SearchFieldWrapper;
SearchField.Cancel = CancelButton;
export default SearchField;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Search/SearchField.linaria.css");